// extracted by mini-css-extract-plugin
export var dropdown = "_sw-0";
export var imageWrapper = "_sw-3";
export var itemNameContainer = "_sw-1";
export var productImage = "_sw-2";
export var spinnerWrapper = "_sw-4";